// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__k5xg-","remaining":"Navbar_remaining__CrKDL"};